import { Trans } from 'react-i18next'
import styled from 'styled-components'

interface VideoTourFooterProps {
  body1?: string
  body2?: string
  body3?: string
}

export const VideoTourFooter = ({
  body1 = 'basics.body1',
  body2 = 'basics.body2',
  body3 = 'basics.body3'
}: VideoTourFooterProps) => {
  return (
    <BasicTourList>
      <p className="msg"><Trans i18nKey={body1} /></p>
      <p className="msg"><Trans i18nKey={body2} /></p>
      <p className="msg"><Trans i18nKey={body3} /></p>
    </BasicTourList>
  )
}

const BasicTourList = styled.div`
  text-align: center;
  margin: 32px 0;
  .msg {
    color: #616C78;
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
  }
  .msg > span {
    color: #616C78;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 19px;
  }
`